import React from "react";
import { ModuleI, BottomNavigationBarType } from "../../../types";

interface TopicSideNavProps {
  module: ModuleI;
  onLessonSelect: (lessonId: string, pageIndex?: number) => void;
}

const TopicSideNav: React.FC<TopicSideNavProps> = ({
  module,
  onLessonSelect,
}) => {
  return (
    <nav
      aria-label="Topic navigation"
      className="hidden lg:flex flex-col lg:w-80 shrink-0 bg-white rounded-xl border border-gray-200 mb-24"
    >
      {/* Module title */}
      <div className="px-4 py-2 bg-electrum-50 rounded-t-xl">
        <span className="text-xs font-bold tracking-widest uppercase text-electrum">
          {module.title}
        </span>
      </div>

      <ul className="flex flex-col gap-0">
        {module.lessons.map((lesson, lessonIndex) => (
          <li key={lesson._id ?? lesson.title}>
            {/* Section title */}
            <div className="w-full flex items-center gap-3 px-4 py-3 text-gray-600">
              {lesson.icon?.src ? (
                <img
                  src={lesson.icon.src}
                  alt={lesson.icon.alt ?? lesson.title}
                  className="h-10 w-10 rounded-full object-cover shrink-0"
                />
              ) : (
                <div className="h-10 w-10 rounded-full bg-electrum-100 shrink-0" />
              )}
              <span className="flex-1 text-sm font-semibold leading-snug text-gray-800">
                {lesson.title}
              </span>
            </div>

            {/* Page list */}
            <ul className="pb-2">
              {lesson.pages.map((page, pageIndex) => (
                <li key={page._id ?? pageIndex}>
                  <button
                    type="button"
                    onClick={() =>
                      onLessonSelect(lesson._id ?? lesson.title, pageIndex)
                    }
                    className="w-full flex items-center gap-3 pl-6 pr-4 py-2 text-left text-sm text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-electrum focus-visible:ring-offset-1"
                  >
                    <span className="shrink-0 flex items-center justify-center h-4 w-4">
                      <span className="h-2 w-2 rounded-full border border-gray-300 block" />
                    </span>
                    <span className="leading-snug">{page.title}</span>
                  </button>
                </li>
              ))}
              {lesson.bottomNavigationBarType !==
                BottomNavigationBarType.SINGLE_PAGE && (
                <li>
                  <button
                    type="button"
                    onClick={() =>
                      onLessonSelect(
                        lesson._id ?? lesson.title,
                        lesson.pages.length,
                      )
                    }
                    className="w-full flex items-center gap-3 pl-6 pr-4 py-2 text-left text-sm text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-electrum focus-visible:ring-offset-1"
                  >
                    <span className="shrink-0 flex items-center justify-center h-4 w-4">
                      <span className="h-2 w-2 rounded-full border border-gray-300 block" />
                    </span>
                    <span className="leading-snug">Recap</span>
                  </button>
                </li>
              )}
            </ul>

            {lessonIndex < module.lessons.length - 1 && (
              <div className="mx-0 border-b border-gray-100" />
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default TopicSideNav;
